var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_10397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 13.4859L13.9841 8.19043",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6544 3.99516L5.05134 9.71279C4.80166 9.96255 4.66139 10.3013 4.66139 10.6544C4.66139 11.0076 4.80166 11.3463 5.05134 11.596C5.3011 11.8457 5.6398 11.986 5.99296 11.986C6.34612 11.986 6.68482 11.8457 6.93458 11.596L12.5377 5.8784C13.037 5.37888 13.3176 4.70148 13.3176 3.99516C13.3176 3.28884 13.037 2.61144 12.5377 2.11193C12.0382 1.61256 11.3608 1.33203 10.6544 1.33203C9.94812 1.33203 9.27072 1.61256 8.7712 2.11193L3.16744 7.82889C2.41806 8.57827 1.99707 9.59464 1.99707 10.6544C1.99707 11.7142 2.41806 12.7306 3.16744 13.4799C3.91681 14.2293 4.93318 14.6503 5.99296 14.6503C7.05273 14.6503 8.0691 14.2293 8.81848 13.4799",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_10397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/shareicon.5d5579a224384371617f663b5ebd7c76.svg";
export { ForwardRef as ReactComponent };